module.exports = __webpack_public_path__ + "img/电研社.87b99cf2.jpg";